import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { LabelComponent } from '../Card/components/LabelComponent.js';

function FiltersItem(_a) {
    var { children, "data-testid": dataTestId, labelTypography, sxLabel, label } = _a, restProps = __rest(_a, ["children", "data-testid", "labelTypography", "sxLabel", "label"]);
    return (jsxs(Container, Object.assign({ "data-testid": dataTestId }, restProps, { children: [jsx(LabelComponent, { "data-testid": dataTestId ? `${dataTestId}-label` : undefined, sx: sxLabel, typographyProps: labelTypography, children: label }), children] })));
}
const Container = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(4),
}));

export { FiltersItem };
//# sourceMappingURL=FiltersItem.js.map
